<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div class="container-fluid p-4">
      <span class="pageSteps card-styling" style="margin-top: 125px">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-weight: 300; font-style: normal">Postagens</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Nova Postagem</p>
      </span>
      <div class="card-styling" style="margin-top: 32px">
        <StepProgress
          :mySteps="mystep"
          :currentStep="currentStep"
          @checkCurrentStep="checkCurrentStep"
        />

        <form
          class="d-flex flex-column w-100 align-items-center justify-content-between"
        >
          <div class="w-100" v-show="step === 0">
            <span>
              <span class="d-flex algin-items-center flex-wrap">
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Escolha a conta da loja para publicação
                </h3>
                &nbsp;&nbsp;
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--blue-dark);
                  "
                >
                  #MarketingNaLoja
                </h3>
              </span>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Nós iremos fazer a publicação na conta do instagram da loja
                selecionada nesta etapa
              </p>
            </span>
            <InputSearch @onUpdate="(value) => getStoreByName(value)" />
            <div class="d-flex flex-column mt-4">
              <Accordion :title="'Regionais'" v-if="nameToSearch.length === 0">
                <SubAccordion
                  :title="Rstore[0].regionalName"
                  :id="`${Rstore.id}`"
                  v-for="Rstore in Rstores"
                  :key="Rstore.id"
                  @selectAll="(regional) => selectAllRegional(regional)"
                >
                  <AccordionItem
                    v-for="store in Rstore"
                    :key="store.id"
                    :item="store"
                    :selected="storeIsChecked(store.instaPageId)"
                    @filter="
                      (checked) =>
                        isSelected(
                          checked,
                          store.id,
                          store.instaPageId,
                          store.pageName
                        )
                    "
                  />
                </SubAccordion>
              </Accordion>
              <Accordion
                :title="'Lojas'"
                :stores="true"
                @selectAll="selectAll(stores)"
              >
                <AccordionItem
                  v-for="store in stores"
                  :key="store.id"
                  :item="store"
                  :selected="storeIsChecked(store.instaPageId)"
                  @filter="
                    (checked) =>
                      isSelected(
                        checked,
                        store.id,
                        store.instaPageId,
                        store.pageName
                      )
                  "
                />
              </Accordion>
            </div>
          </div>

          <div class="w-100" v-show="step === 1">
            <span>
              <span class="d-flex algin-items-center flex-wrap">
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Escolha quando deverá ser publicado
                </h3>
                &nbsp;&nbsp;
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--blue-dark);
                  "
                >
                  #MarketingNaLoja
                </h3>
              </span>

              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Escolha se a publicação deverá ser postada imediatamente ou em
                data agendada
              </p>
            </span>
            <section>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  color: var(--black-medium);
                "
              >
                Imediatamente
              </p>
              <div class="forToday">
                <label for="selectForToday">Fazer a publicação agora</label>
                <input
                  type="checkbox"
                  name=""
                  checked="checked"
                  id="selectForToday"
                  @click="clickForToday()"
                  style="border-radius: 100%"
                />
              </div>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  color: var(--black-medium);
                "
              >
                Agendar
              </p>
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <v-date-picker
                    v-if="!isForToday"
                    v-model="post.date"
                    mode="date"
                    :columns="2"
                    :min-date="new Date()"
                    :max-date="maxMonth"
                    :locale="{
                      firstDayOfWeek: 2,
                      masks: { weekdays: 'WWW', title: 'MMMM' },
                    }"
                    style="
                      margin-bottom: 8px;
                      border: none;
                      background-color: var(--blue-light);
                      z-index: 0;
                    "
                    @dayclick="clickForToday()"
                  />
                  <v-date-picker
                    v-else
                    v-model="post.date"
                    mode="date"
                    :columns="2"
                    :disabled-dates="true"
                    :locale="{
                      firstDayOfWeek: 2,
                      masks: { weekdays: 'WWW', title: 'MMMM' },
                    }"
                    style="
                      margin-bottom: 8px;
                      border: none;
                      background-color: var(--blue-light);
                      z-index: 0;
                    "
                  />
                  <select
                    v-model="post.time"
                    style="margin-bottom: 22px; outline: none"
                    class="form-select"
                    @change="clickForToday()"
                    :disabled="isForToday"
                  >
                    <option value="" disabled selected>Horário</option>
                    <option
                      v-for="(option, index) in options"
                      :selected="option == post.time"
                      :key="index"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          <div class="w-100" v-show="step === 2">
            <div v-show="!publish && !isDetails">
              <span>
                <span class="d-flex algin-items-center flex-wrap">
                  <h3
                    style="
                      font-style: normal;
                      font-weight: 700;
                      font-size: 34px;
                      color: var(--grey-medium);
                    "
                  >
                    Configure a sua postagem
                  </h3>
                  &nbsp;&nbsp;
                  <h3
                    style="
                      font-style: normal;
                      font-weight: 700;
                      font-size: 34px;
                      color: var(--blue-dark);
                    "
                  >
                    #MarketingNaLoja
                  </h3>
                </span>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--black-medium);
                  "
                >
                  Escolha um dos templates abaixo para adicionar a sua
                  publicação
                </p>
              </span>
              <section>
                <div
                  style="position: relative; z-index: 0"
                  class="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <div
                    v-for="category in library"
                    :key="category.instagramLibraryCategory.id"
                    class="accordion-item"
                  >
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed h1-button"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="
                          '#flush-collapse' +
                          category.instagramLibraryCategory.id
                        "
                        aria-expanded="false"
                        :aria-controls="
                          'flush-collapse' +
                          category.instagramLibraryCategory.id
                        "
                      >
                        {{ category.instagramLibraryCategory.name }}
                      </button>
                    </h2>
                    <div
                      :id="
                        'flush-collapse' + category.instagramLibraryCategory.id
                      "
                      class="accordion-collapse collapse"
                      :aria-labelledby="
                        'flush-heading' + category.instagramLibraryCategory.id
                      "
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div
                        class="accordion-body flex-wrap w-100 d-flex justify-content-center align-items-center"
                      >
                        <div
                          v-for="(template, index) in category.images"
                          :key="index"
                          style="
                            border-radius: 8px;
                            margin: 12px;
                            width: 150px;
                            height: 150px;
                            position: relative;
                          "
                        >
                          <img
                            v-if="
                              template.file.includes('.jpg') ||
                              template.file.includes('.jpeg')
                            "
                            :id="'template' + index"
                            class="cursor-pointer"
                            style="max-width: 100%; max-height: 100%"
                            :src="template.file"
                            alt="ícone de
                          categorias da biblioteca"
                            @click="clickTemplate(template.id, template.file)"
                          />
                          <video
                            v-else
                            :id="'template' + index"
                            class="cursor-pointer"
                            style="max-width: 100%; max-height: 100%"
                            :src="template.file"
                            alt="ícone de categorias da biblioteca"
                            @click="clickTemplate(template.id, template.file)"
                          />
                          <input
                            type="hidden"
                            id="openModalViewSelectedTemplate"
                            data-bs-toggle="modal"
                            data-bs-target="#modalViewSelectedTemplate"
                          />
                          <img
                            v-if="
                              selectedTemplates.findIndex(
                                (x) => x.templateId === template.id
                              ) != -1
                            "
                            class="cursor-pointer"
                            style="
                              max-width: 100%;
                              max-height: 100%;
                              position: absolute;
                              top: 8px;
                              right: 8px;
                            "
                            :src="
                              require('@/assets/images/svg/ícone-imagem-selecionada.svg')
                            "
                            alt="ícone para indicar loja selecionada"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div v-show="stepEnd">
              <span
                v-if="isDetails"
                class="d-flex algin-items-center flex-wrap"
              >
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Configure a sua postagem
                </h3>
                &nbsp;&nbsp;
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--blue-dark);
                  "
                >
                  #MarketingNaLoja
                </h3>
              </span>
              <p
                v-if="isDetails"
                style="
                  max-width: 600px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Adicione produtos a sua mídia e uma descrição com hashtags a sua
                postagem
              </p>
              <span v-if="publish" class="d-flex algin-items-center flex-wrap">
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Tudo certo!
                </h3>
                &nbsp;&nbsp;
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--blue-dark);
                  "
                >
                  #MarketingNaLoja
                </h3>
              </span>
              <p
                v-if="publish && isForToday"
                style="
                  max-width: 600px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Publicação realizada com sucesso. Ela será publicada na conta do
                instagram escolhida
              </p>
              <p
                v-if="publish && isForToday == false"
                style="
                  max-width: 600px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                A sua publicação foi agendada com sucesso. No dia e hora
                escolhidos ela será publicado na conta do instagram escolhida
              </p>
              <section
                class="d-flex align-items-center justify-content-center w-100 flex-wrap"
              >
                <div
                  class="d-flex flex-column align-item-center justify-content-center"
                  style="margin: 16px"
                >
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 14px;
                      color: var(--black-medium);
                    "
                  >
                    Mídia
                  </p>
                  <div
                    v-if="
                      selectedTemplates.length > 0 &&
                      selectedTemplates.length < 2
                    "
                  >
                    <img
                      v-if="
                        selectedTemplates[0].templateFile.includes('.jpg') ||
                        selectedTemplates[0].templateFile.includes('.jpeg')
                      "
                      :src="selectedTemplates[0].templateFile"
                      width="350"
                      height="350"
                      alt=""
                      style="border-radius: 8px"
                    />
                    <video
                      v-else
                      :src="selectedTemplates[0].templateFile"
                      width="350"
                      height="350"
                      alt=""
                      style="border-radius: 8px"
                    />
                  </div>
                  <div
                    v-if="selectedTemplates.length > 1"
                    id="carouselExampleControls"
                    class="carousel slide"
                    data-bs-interval="false"
                    style="text-shadow: 1px 1px 2px #333"
                  >
                    <div class="carousel-inner">
                      <div
                        v-for="(template, index) in selectedTemplates"
                        :key="index"
                        class="carousel-item"
                        :class="index === 0 ? 'active' : ''"
                      >
                        <img
                          :src="template.templateFile"
                          class="img-fluid d-block img-responsivo"
                          alt="Template"
                          style="width: 350px"
                        />
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
                <div
                  class="d-flex flex-column align-item-center justify-content-between col-xl-5 col-md-5 col-12"
                  style="margin: 16px"
                >
                  <SelectedStore
                    v-if="publish"
                    :storeName="onlySelectedStore"
                  />
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 14px;
                      color: var(--black-medium);
                    "
                  >
                    Descrição
                  </p>
                  <textarea
                    v-model="post.caption"
                    class="w-100"
                    style="resize: none; height: 250px"
                    :readonly="isDetails && !publish ? false : true"
                    maxlength="2200"
                  >
                  </textarea>
                  <div
                    v-if="publish"
                    id="footer-date-time"
                    class="w-100 d-flex align-items-center"
                  >
                    <Input
                      space="date"
                      :inputValue="ptBRdateFormat"
                      :inputType="'text'"
                      :inputLabel="'Data'"
                      :inputTypeNotValidation="true"
                      :disabled="true"
                      :justView="true"
                    />
                    <Input
                      space="time"
                      :inputValue="post.time != '' ? post.time : ptBRTimeFormat"
                      :inputType="'text'"
                      :inputLabel="'Horário'"
                      :inputTypeNotValidation="true"
                      :disabled="true"
                      :justView="true"
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
          <footer
            class="w-100 d-flex justify-content-end"
            style="margin-top: 22px"
          >
            <button
              v-if="!isDetails && !publish"
              @click.prevent="backStep"
              type="button"
              class="btn-no-width btn-back col-12 col-sm-4"
              style="
                color: var(--blue-medium);
                background-color: var(--blue-light);
              "
            >
              Anterior
            </button>
            <button
              v-if="step == 2 && !publish && isDetails"
              @click.prevent="
                () => {
                  isDetails = false;
                  stepEnd = false;
                }
              "
              type="button"
              class="btn-no-width btn-back col-12 col-sm-4"
              style="
                color: var(--blue-medium);
                background-color: var(--blue-light);
              "
            >
              Anterior
            </button>
            <button
              v-if="step < 2 && !publish"
              @click.prevent="nextStep"
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4"
              style="color: var(--white)"
            >
              Próximo
            </button>
            <button
              v-if="step == 2 && !publish && !isDetails"
              @click.prevent="
                () => {
                  isDetails = true;
                  stepEnd = true;
                }
              "
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4"
              style="color: var(--white)"
            >
              Próximo
            </button>
            <button
              v-if="step == 2 && !publish && isDetails"
              @click.prevent="savePost"
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4"
              style="color: var(--white)"
            >
              Salvar
            </button>
            <router-link
              v-if="step == 2 && publish"
              :to="{ name: 'Posts' }"
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4 text-decoration-none text-center"
              style="color: var(--white)"
            >
              Fechar
            </router-link>
          </footer>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalViewSelectedStores"
      tabindex="1"
      aria-labelledby="modalViewSelectedStores"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body table-responsive w-100">
            <table class="table align-middle">
              <tbody>
                <tr v-for="(name, index) in nameOfSelectedStores" :key="index">
                  <td>
                    <img
                      :src="require('@/assets/images/svg/ícone-loja.svg')"
                      alt=""
                      style="margin-right: 10px"
                    />
                  </td>
                  <td>{{ name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalViewSelectedTemplate"
      tabindex="1"
      aria-labelledby="modalViewSelectedTemplate"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <h3
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 34px;
                color: var(--grey-medium);
              "
            >
              Confirme a escolha do template
            </h3>
          </div>
          <div
            class="modal-body w-100 d-flex justify-content-center align-items-center"
          >
            <img
              v-if="
                this.templateFile.includes('jpg') ||
                this.templateFile.includes('jpeg')
              "
              style="max-width: 100%; max-height: 500px"
              :src="this.templateFile"
              alt=""
            />
            <video
              v-else
              style="max-width: 100%; max-height: 500px"
              :src="this.templateFile"
              alt=""
              controls
            />
          </div>
          <div class="modal-footer" style="flex-wrap: initial">
            <button
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: transparent;
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn-default"
              style="
                color: var(--blue-medium);
                background-color: var(--blue-light);
              "
              @click="uncheckTemplate"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Desselecionar
            </button>
            <button
              type="button"
              class="btn-default"
              style="color: var(--white); background-color: var(--blue-medium)"
              @click="confirmTemplate"
            >
              Selecionar
            </button>
            <input
              type="hidden"
              id="closeModalViewSelectedTemplate"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepProgress from "../components/StepProgress.vue";
import Pagination from "@/components/Pagination.vue";
import Store from "@/components/Store.vue";
import SelectedStore from "@/components/SelectedStore.vue";
import InputSearch from "../components/InputSearch.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import apiGerenciarMidias from "../service/apiGerenciarMidiasService";
import Loading from "vue-loading-overlay";
import Input from "@/components/Input.vue";

import Accordion from "@/components/ui/accordion/accordion.vue";
import AccordionItem from "@/components/ui/accordion/accordionItem.vue";
import SubAccordion from "@/components/ui/accordion/subAccordion.vue";

export default {
  components: {
    StepProgress,
    InputSearch,
    Loading,
    SelectedStore,
    Input,
    Accordion,
    AccordionItem,
    SubAccordion,
  },
  name: "NewPostMarketing",
  data() {
    return {
      post: {
        storeSelected: [],
        containerMidias: [],
        date: undefined,
        time: "",
        caption: "",
      },
      mystep: ["Loja", "Configuração", "Publicação"],
      stores: [],
      Rstores: {},
      options: [],
      library: [],
      nameOfSelectedStores: [],
      step: 0,
      currentStep: 0,
      totalStores: 0,
      offset: 0,
      nameToSearch: "",
      templateUrl: "",
      templateId: undefined,
      templateFile: "",
      isDisabled: true,
      isForToday: false,
      isSelectedTemplate: false,
      isLoading: false,
      publish: false,
      isDetails: false,
      stepEnd: false,
      selectedTemplates: [],
      isBatch: true,
    };
  },
  watch: {
    handleStatusCode(payload) {
      if (payload === 200) {
        this.publish = true;
      }
    },
    getInstaMidiaContainer(arrayMidia) {
      this.isLoading = true;
      this.registerPostBatch(arrayMidia);
    },
    getInstaMidiaPosts(midiasPosts) {
      this.isLoading = true;

      if (midiasPosts.status === "fulfilled" || midiasPosts.status === 200) {
        this.publish = true;
      }

      this.isLoading = false;
    },
  },
  async created() {
    //exibe component loading
    this.isLoading = true;

    await this.getStoresByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 3,
    }).then((response) => {
      this.stores = response.data.data;
      this.totalStores = response.data.count;

      response.data.groupedRegional.map((store) => {
        if (store.regional in this.Rstores) {
          // ok
        } else {
          this.Rstores[store.regional] = store.lojas;
        }
      });
      
    });

    await this.intervalosNoDia(30).forEach((l) => {
      let option = `${String(l.getUTCHours()).padStart(2, "0")}:${String(
        l.getUTCMinutes()
      ).padStart(2, "0")}`;
      this.options.push(option);
    });

    await this.categories();

    //fecha component loading
    this.isLoading = false;

    // this.getStoresByRegional().then((response) => {
    //   this.Rstores = response.data;
    // });
  },
  computed: {
    ...mapGetters([
      "getOffset",
      "getInstaMidiaContainer",
      "getInstaMidiaPosts",
      "isLoadingPost",
      "handleStatusCode",
    ]),

    maxMonth() {
      let currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 1);
    },
    onlySelectedStore() {
      return this.nameOfSelectedStores.length > 0 &&
        this.nameOfSelectedStores.length < 2
        ? this.nameOfSelectedStores[0]
        : "";
    },
    ptBRdateFormat() {
      let date =
        this.post.date != undefined ? new Date(this.post.date) : new Date();
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();

      return new Date(year, month, day).toLocaleDateString("pt-BR");
    },
    ptBRTimeFormat() {
      let date = this.post.time != "" ? "" : new Date();
      let hours = date != "" ? date.getHours() : this.post.time.substring(0, 2);
      let minutes =
        date != "" ? date.getMinutes() : this.post.time.substring(3);

      return `${hours}:${minutes}`;
    },
  },
  methods: {
    ...mapActions([
      "getStoresByPagination",
      "getLibrary",
      "getStoresByRegional",
      "uploadMediaToContainerBatch",
      "registerPostBatch",
      "isLoadingPostSet",
    ]),
    ...mapMutations(["SET_OFFSET"]),

    nextStep() {
      if (this.currentStep < this.mystep.length - 1) {
        this.currentStep++;
      }
      if (this.currentStep === 1) {
        this.clickForToday();
      } else {
        this.isDisabled = true;

        if (this.isSelectedTemplate) {
          this.isDisabled = false;
        }
      }
    },
    backStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    checkCurrentStep(val) {
      this.step = val;
    },
    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },
    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 3,
      };

      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getStoresByPagination(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    isSelected(checked, id, instaPageId, storeName) {
      if (this.post.storeSelected.length > 0) {
        if (this.post.storeSelected.includes(instaPageId)) {
          if (!checked) {
            this.post.storeSelected.splice(
              this.post.storeSelected.indexOf(instaPageId),
              1
            );
            this.nameOfSelectedStores.splice(
              this.nameOfSelectedStores.indexOf(storeName),
              1
            );

            if (this.post.storeSelected.length === 0) this.isDisabled = true;
          }
        } else {
          this.isDisabled = false;
          this.post.storeSelected.push(instaPageId);
          this.nameOfSelectedStores.push(storeName);
        }
      } else {
        this.isDisabled = false;
        this.post.storeSelected.push(instaPageId);
        this.nameOfSelectedStores.push(storeName);
      }
    },
    selectAll(items) {
      let intArr = Array.from(this.post.storeSelected);
      const storesIds = items.map((store) => store.instaPageId);
      const storesName = items.map((store) => store.pageName);

      if (intArr.length === 0) {
        this.isDisabled = false;
        this.post.storeSelected = storesIds;
        this.nameOfSelectedStores = storesName;
      } else if (intArr.length !== storesIds.length && intArr.length > 0) {
        this.post.storeSelected = [];
        this.nameOfSelectedStores = [];

        this.post.storeSelected = storesIds;
        this.nameOfSelectedStores = storesName;
      } else {
        this.isDisabled = true;
        this.post.storeSelected = [];
        this.nameOfSelectedStores = [];
      }
    },
    clickForToday() {
      this.isForToday = document.getElementById("selectForToday").checked;

      if (this.isForToday) {
        this.isDisabled = false;
      } else {
        if (this.post.time != "" && this.post.date != undefined) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      }
    },
    dateAndTimeFormatting() {
      let date = new Date(this.post.date);
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let hours = this.post.time.substring(0, 2);
      let minutes = this.post.time.substring(3);
      let mountedDateAndTime = new Date(year, month, day, hours, minutes, 0, 0);

      return mountedDateAndTime.toISOString();
    },
    intervalosNoDia(minutosPorIntervalo) {
      const minutes = 1000 * 60 * minutosPorIntervalo;
      const steps = (1000 * 60 * 60 * 24) / minutes;
      const lista = [];

      for (let step = 0; step < steps; step++) {
        lista.push(new Date(step * minutes));
      }

      return lista;
    },

    async uploadMidiaInApiContainerBatch() {
      try {
        await this.uploadMediaToContainerBatch({
          midias: null,
          templates: this.selectedTemplates,
          post: this.post,
        });
      } catch (error) {
        this.approvedImage = false;
      }
    },
    async savePost() {
      this.isLoading = true;
      // this.isLoadingPostSet(true);
      this.stepEnd = true;

      await this.uploadMidiaInApiContainerBatch();

      setTimeout(() => {
        if (localStorage.getItem("status")) {
          this.publish = true;
          setTimeout(() => {
            localStorage.removeItem("status");
            this.isLoading = false;
          }, 3000);
        }
      }, 5000);
    },
    async categories() {
      try {
        const response = await apiGerenciarMidias.getCategoryWithMedias();
        if (response.status === 200) {
          this.library = response.data.data;
        } else {
          // console.log(response);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async clickTemplate(idTemplate, file) {
      this.isLoading = true;
      this.templateId = undefined;
      this.templateFile = "";
      this.templateId = idTemplate;
      this.templateFile = file;
      this.templateUrl = `${process.env.VUE_APP_API_URL}/api/InstagramLibraryUpload/GetImage?InstagramLibraryMediaId=${idTemplate}`;
      this.isLoading = false;

      //abrir modal
      document.getElementById("openModalViewSelectedTemplate").click();
    },
    confirmTemplate() {
      if (
        this.selectedTemplates.length > 0 &&
        this.selectedTemplates.length < 10
      ) {
        let ind = this.selectedTemplates.findIndex(
          (x) => x.templateId === this.templateId
        );

        if (ind == -1) {
          this.selectedTemplates.push({
            templateUrl: this.templateUrl,
            templateId: this.templateId,
            templateFile: this.templateFile,
          });
        }
      }
      if (this.selectedTemplates.length === 0) {
        this.selectedTemplates.push({
          templateUrl: this.templateUrl,
          templateId: this.templateId,
          templateFile: this.templateFile,
        });
      }

      this.isDisabled = false;

      //fechar modal
      document.getElementById("closeModalViewSelectedTemplate").click();
    },
    uncheckTemplate() {
      if (this.selectedTemplates.length > 0) {
        let ind = this.selectedTemplates.findIndex(
          (x) => x.templateId === this.templateId
        );

        if (ind != -1) {
          this.selectedTemplates.splice(ind, 1);
        }
      }

      this.templateFile = "";
      this.templateId = undefined;
      this.isDisabled = this.selectedTemplates.length > 0 ? false : true;
    },
    storeIsChecked(id) {
      if (this.post.storeSelected.includes(id)) {
        return true;
      } else {
        return false;
      }
    },
    selectAllRegional(regionalName) {
      const regional = this.Rstores[regionalName].map(
        (store) => store.instaPageId
      );
      const storesName = this.Rstores[regionalName].map(
        (store) => store.pageName
      );

      const has = regional.every((id) => this.post.storeSelected.includes(id));

      if (has) {
        regional.map((id) => {
          const index = this.post.storeSelected.indexOf(id);

          if (index !== -1) {
            this.post.storeSelected.splice(index, 1);
          }
        });

        storesName.map((name) => {
          const index = this.nameOfSelectedStores.indexOf(name);

          if (index !== -1) {
            this.nameOfSelectedStores.splice(index, 1);
          }
        });
      } else {
        this.post.storeSelected = [...this.post.storeSelected, ...regional];
        this.nameOfSelectedStores = [
          ...this.nameOfSelectedStores,
          ...storesName,
        ];
      }

      if (this.post.storeSelected.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}

.btnMultipleImages,
.btnNotMultipleImages {
  background-color: transparent;
  border: 1px solid var(--blue-medium);
  border-radius: 8px;
  color: var(--blue-medium);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  cursor: pointer;
  text-align: center;
}

.btnMultipleImages {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 150px;
}

.btn-back {
  margin-right: 8px;
}

.btn-next {
  margin-left: 8px;
}

.able {
  background-color: var(--grey-border);
}

.not-enabled {
  background-color: var(--blue-medium);
}

textarea {
  border: none;
  border-radius: 4px;
  padding: 12px 16px;
  background-color: var(--backgroundColor);
}

select {
  height: 48px;
  background-image: url("~@/assets/images/svg/ícone-seta-para-baixo-azul.svg") !important;
  background-color: var(--grey-light);
  border: none;
  color: var(--black-medium);
}

select:disabled {
  background-image: url("~@/assets/images/svg/ícone-seta-para-baixo-cinza.svg") !important;
  background-color: var(--grey-light);
  color: var(--grey-border);
}

select > option:checked {
  color: var(--black-medium);
}

select > option {
  color: var(--black-medium);
}

.forToday {
  background: var(--backgroundColor);
  border-radius: 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14.5px 16px;
  margin-bottom: 24px;
}

.time,
.date {
  margin-top: 1rem;
}

.time {
  margin-left: 8px;
}

.date {
  margin-right: 8px;
}

@media screen and (max-width: 563px) {
  .bl-responsive-stores {
    flex-direction: column;
  }
}

@media screen and (max-width: 576px) {
  footer {
    flex-direction: column;
  }

  .btn-back {
    margin-right: 0;
    margin-bottom: 8px;
  }

  .btn-next {
    margin-left: 0;
    margin-top: 8px;
  }
}

@media only screen and (max-width: 530px) {
  #footer-date-time {
    flex-direction: column;
  }

  .time {
    margin-left: 0;
  }

  .date {
    margin-right: 0;
  }
}
</style>
<style>
.form-select:focus {
  box-shadow: none !important;
}
</style>
